<template>
    <div class="border-light-grey py-1 py-sm-3 d-flex align-items-center justify-content-center justify-content-md-start">
        <div class="d-flex align-items-center flex-column flex-md-row pb-2 py-md-2">
            <div class="d-flex justify-content-center justify-content-sm-start">
                <div class="h3 mb-0 mr-2 ic-wrapper">
                    <b-link :to="profileArrowLink">
                        <SvgIcon name="arrow-left" :width="22" :height="22"/>
                    </b-link>
                </div>
                <!-- arrow -->
                <div class="dam-name mr-md-3 d-flex align-items-center">
                    {{ currentDamSelectedName }}
                </div>
            </div>
            <div class="px-4">
                <StatusDotText
                    :status-arr="currentDamSelectedStatus"
                    :large-dot="true"
                    :overflow-info="currentDamOverflowInfo"
                ></StatusDotText>
            </div>
        </div>
    </div>
</template>

<script>
    // utils
    import {mapGetters} from "vuex";
    // components
    import StatusDotText from "../../components/shared/StatusDotText";
    // assets
    import SvgIcon from '../shared/SvgIcon';
    // TODO: generate buttons, based on sensors?
    import arrowLeft from '../../assets/img/icons/arrow-left.svg';

    export default {
        name: "ProfileToolBar",
        components: {
            StatusDotText,
            SvgIcon
        },
        computed: {
           ...mapGetters(['currentDamSelectedName', 'currentDamSelectedStatus', 'getPsData', 'currentDamOverflowInfo']),
            profileArrowLink() {
                let backToObj = {name: 'dashboard'};
                if (this.$route.params.id) {
                    backToObj['params'] = {id: this.$route.params.id}
                }
                return backToObj;
            }
        },
        data () {
            return {
                img: {
                    arrowLeft
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "src/assets/scss/_variables";

    .dam-name {
        text-align: left;
        font: normal normal 600 16px/22px Nunito, sans-serif;
        letter-spacing: 0px;
        color: $menuBlue;
        opacity: 1;
    }

    .border-light-grey {
        border-bottom: 1px solid $lightGrey;
    }

    /*.img-wrapper {*/
    /*    box-shadow: 0px 1px 6px #8781CA45;;*/
    /*    border-radius: 3.38px;*/
    /*    margin: 0 5px;*/
    /*    padding: 4px;*/
    /*    min-width: 27px;*/
    /*    text-align: center;*/
    /*}*/

    /*.dam-tool {*/
    /*    max-width: 20px;*/
    /*}*/
</style>